import {addCircularTabFocus, focusElement, hookToAttributeSelector} from '@wix/panda-js-utils'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useEffect} from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {useAppActions, useAppSelector} from '../../../../../hooks/runtime'
import {getSeatingErrorPlanPlaceId} from '../../../../../selectors/seating/errors'
import {getTotalPlaceQuantity} from '../../../../../selectors/seating/place'
import {getAnyPlaceById, getPlaces} from '../../../../../selectors/seating/places'
import {CloseButton} from '../../../common/close-button'
import {StyledButton} from '../../styled-button'
import {classes} from '../error-modal.st.css'

export const PlaceCapacityReached = () => {
  const {t} = useTranslation()
  const {isMobile} = useEnvironment()
  const {setSeatingError} = useAppActions()

  const places = useAppSelector(getPlaces)
  const errorPlaceId = useAppSelector(getSeatingErrorPlanPlaceId)

  const {capacity} = getAnyPlaceById(places, errorPlaceId)
  const totalPlaceQuantity = getTotalPlaceQuantity(places, errorPlaceId)
  const ticketsLeft = capacity - totalPlaceQuantity

  useEffect(() => {
    focusElement({selector: hookToAttributeSelector(DH.MODAL_TITLE)})
    addCircularTabFocus(
      hookToAttributeSelector(DH.CLOSE_BUTTON),
      hookToAttributeSelector(DH.PLACE_CAPACITY_REACHED_MODAL_BUTTON),
    )
  }, [])

  return (
    <div role="dialog" aria-modal="true" className={classes.container}>
      <div className={classNames(classes.content, {[classes.desktopContent]: !isMobile})}>
        <CloseButton
          className={classes.closeIcon}
          closeButtonAsButton={false}
          closeModal={() => setSeatingError(null)}
        />
        <div className={classes.text}>
          <Text
            data-hook={DH.MODAL_TITLE}
            tagName="h2"
            className={classNames(classes.title, {[classes.mobileTitle]: isMobile})}
          >
            {ticketsLeft
              ? t('seatings_placeCapacityReachedModal_title', {count: ticketsLeft})
              : t('seatings_placeCapacityReachedModal_noTicketsLeft_title')}
          </Text>
          <Text data-hook={DH.MODAL_TEXT} tagName="p" className={classes.subtitle}>
            {ticketsLeft
              ? t('seatings_placeCapacityReachedModal_subtitle')
              : t('seatings_placeCapacityReachedModal_noTicketsLeft_subtitle')}
          </Text>
        </div>
        <StyledButton
          dataHook={DH.PLACE_CAPACITY_REACHED_MODAL_BUTTON}
          onClick={() => setSeatingError(null)}
          fullWidth={false}
        >
          {t('seatings_placeCapacityReachedModal_button')}
        </StyledButton>
      </div>
    </div>
  )
}
